import React from 'react';
import { Box, Typography } from '@mui/material';
import { color, radius, shadow } from '../../theme/tokens';

/**
 * Compact metric tile: label, big number, optional hint + delta.
 * Deliberately restrained (no rainbow icon tiles) so numbers stay the focus.
 */
const MetricCard = ({ label, value, hint, icon, delta, deltaTone = 'neutral', loading, sx }) => {
  const deltaColor =
    deltaTone === 'success' ? color.success.text :
    deltaTone === 'danger'  ? color.danger.text :
    color.ink[500];

  return (
    <Box
      sx={{
        bgcolor: color.surface,
        border: `1px solid ${color.border}`,
        borderRadius: `${radius.xl}px`,
        boxShadow: shadow.xs,
        p: 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        transition: 'border-color .15s ease',
        '&:hover': { borderColor: color.borderStrong },
        ...sx,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
        <Typography sx={{ fontSize: '0.8125rem', fontWeight: 500, color: color.ink[500] }}>
          {label}
        </Typography>
        {icon && (
          <Box sx={{ color: color.ink[400], display: 'flex', '& svg': { fontSize: 18 } }}>{icon}</Box>
        )}
      </Box>

      <Typography
        sx={{
          fontSize: '1.75rem',
          fontWeight: 600,
          color: color.ink[900],
          lineHeight: 1.1,
          letterSpacing: '-0.02em',
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {loading ? '—' : (value ?? '—')}
      </Typography>

      {(hint || delta) && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minHeight: 18 }}>
          {delta && (
            <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: deltaColor }}>
              {delta}
            </Typography>
          )}
          {hint && (
            <Typography sx={{ fontSize: '0.75rem', color: color.ink[500] }}>{hint}</Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default MetricCard;
